// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"ebe72a28","159":"7ed8e409","239":"8f652ec3","332":"40b38ca4","357":"4079cb3f","396":"c33a625a","412":"83b66ef8","455":"c6c98515","647":"c7abf2f9","782":"2d87de3a","977":"8de305f7","982":"0abdd3a8"}[chunkId] + ".chunk.js";
};